import {
  EMPTY_QETAF,
  ERROR_QETAF_COMPLETE,
  ERROR_QETAF_OTP,
  ERROR_QETAF_REDEEM,
  ERROR_QETAF_REVERSE,
  ERROR_QETAF_UPDATE_REWARD,
  FETCH_QETAF_COMPLETE,
  FETCH_QETAF_OTP,
  FETCH_QETAF_REDEEM,
  FETCH_QETAF_REVERSE,
  FETCH_QETAF_UPDATE_REWARD,
  LOAD_QETAF_COMPLETE,
  LOAD_QETAF_OTP,
  LOAD_QETAF_REDEEM,
  LOAD_QETAF_REVERSE,
  LOAD_QETAF_UPDATE_REWARD,
} from "../Actions/Types";

const initialState = {
  otpResponse: null,
  redeemResponse: null,
  completeResponse: null,
  reverseResponse: null,
  updateRewardResponse: null,
  otpLoading: false,
  redeemLoading: false,
  completeLoading: false,
  reverseLoading: false,
  updateRewardLoading: false,
  otpError: "",
  redeemError: "",
  completeError: "",
  reverseError: "",
  updateRewardError: "",
  otpSuccess: false,
  redeemSuccess: false,
  completeSuccess: false,
  reverseSuccess: false,
  updateRewardSuccess: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case LOAD_QETAF_OTP:
      return {
        ...state,
        otpLoading: true,
        otpError: "",
        otpSuccess: false,
      };
    case FETCH_QETAF_OTP:
      return {
        ...state,
        otpResponse: action.payload,
        otpLoading: false,
        otpError: "",
        otpSuccess: true,
      };
    case ERROR_QETAF_OTP:
      return {
        ...state,
        otpLoading: false,
        otpError: action.payload,
        otpSuccess: false,
      };
    case LOAD_QETAF_REDEEM:
      return {
        ...state,
        redeemLoading: true,
        redeemError: "",
        redeemSuccess: false,
      };
    case FETCH_QETAF_REDEEM:
      return {
        ...state,
        redeemResponse: action.payload,
        redeemLoading: false,
        redeemError: "",
        redeemSuccess: true,
      };
    case LOAD_QETAF_COMPLETE:
      return {
        ...state,
        completeLoading: true,
        completeError: "",
        completeSuccess: false,
      };
    case FETCH_QETAF_COMPLETE:
      return {
        ...state,
        completeResponse: action.payload,
        completeLoading: false,
        completeError: "",
        completeSuccess: true,
      };
    case ERROR_QETAF_COMPLETE:
      return {
        ...state,
        completeLoading: false,
        completeError: action.payload,
        completeSuccess: false,
      };
    case ERROR_QETAF_REDEEM:
      return {
        ...state,
        redeemLoading: false,
        redeemError: action.payload,
        redeemSuccess: false,
      };
    case LOAD_QETAF_REVERSE:
      return {
        ...state,
        reverseLoading: true,
        reverseError: "",
        reverseSuccess: false,
      };
    case FETCH_QETAF_REVERSE:
      return {
        ...state,
        reverseResponse: action.payload,
        reverseLoading: false,
        reverseError: "",
        reverseSuccess: true,
      };
    case ERROR_QETAF_REVERSE:
      return {
        ...state,
        reverseLoading: false,
        reverseError: action.payload,
        reverseSuccess: false,
      };
    case LOAD_QETAF_UPDATE_REWARD:
      return {
        ...state,
        updateRewardLoading: true,
        updateRewardError: "",
        updateRewardSuccess: false,
      };
    case FETCH_QETAF_UPDATE_REWARD:
      return {
        ...state,
        updateRewardResponse: action.payload,
        updateRewardLoading: false,
        updateRewardError: "",
        updateRewardSuccess: true,
      };
    case ERROR_QETAF_UPDATE_REWARD:
      return {
        ...state,
        updateRewardLoading: false,
        updateRewardError: action.payload,
        updateRewardSuccess: false,
      };
    case EMPTY_QETAF:
      return {
        ...initialState,
      };
    default:
      return state;
  }
}
